/* -- Generated File: Do Not Edit ------------------------------------------ */
export const breakpointValues = {
  breakpointXsmall: 599,
  breakpointSmall: 959,
  breakpointMedium: 1279,
  breakpointLarge: 1919,
  breakpointXlarge: 3840,
};

export default breakpointValues;
/* -- Generated File: Do Not Edit ------------------------------------------ */
